import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';

import api from './../../service/api';
import InputDecimal from '../../components/InputDecimal';

const Truck = () => {
    let emptyTruck = {
        id: null,
        plate: '',
        axle: null,
        description: '',
        average_consumption: null
    };

    const [trucks, setTrucks] = useState([]);
    const [truckDialog, setTruckDialog] = useState(false);
    const [deleteTruckDialog, setDeleteTruckDialog] = useState(false);
    const [truck, setTruck] = useState(emptyTruck);
    const [selectedTrucks, setSelectedTrucks] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);


    const formatCurrency = (value) => {
        return value.toLocaleString('pt-US', { style: 'decimal', minimumFractionDigits: 2 });
    }

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _truck = { ...truck };
        _truck[`${name}`] = val;

        setTruck(_truck);
    }

    const openNew = () => {
        setTruck(emptyTruck);
        setSubmitted(false);
        setTruckDialog(true);
        setDisabled(false);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setTruckDialog(false);
        setDisabled(false);
    }

    const hideDeleteTruckDialog = () => {
        setDeleteTruckDialog(false);
    }
    

    const editTruck = (truck) => {
        setTruck({ ...truck });
        setTruckDialog(true);
    }

    const confirmDeleteTruck = (truck) => {
        setTruck({ ...truck });
        setDeleteTruckDialog(true);
    }

    const handleTruck = () => {
        if(!truck.plate || !truck.axle)
            return setSubmitted(true);
        
        setSubmitted(false);
        setDisabled(true);
        var uri = truck.code ? '/truck/update' : '/truck/create';
        api().post(uri, truck).then(response => {
            if(response.status === 200 && response.data.result){
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listTrucks();
                hideDialog();
            } else {
                toast.current.show({severity: 'warn', summary: 'Atenção', detail: response.data.message});
                setDisabled(false);
            }
        });
    }

    const handleDeleteTruck = () => {
        setDeleteTruckDialog(false);
        api().delete('/truck/' + truck.code).then(response => {
            if(response.status === 200 && response.data.result) {
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listTrucks();
            } else toast.current.show({severity: 'error', summary: 'Erro', detail: response.data.message});
            setTruck(emptyTruck);
        });
    }

    const listTrucks = () => {
        api().get('/truck/list').then(response => {
            if(response.status === 200 && response.data.result){
                setTrucks(response.data.data);
            }
        });
    }

    

    

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Novo" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        )
    }

    


    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mt-2 mr-2" onClick={() => confirmDeleteTruck(rowData)} />
                <Button icon="pi pi-ellipsis-v" className="p-button-rounded p-button-info" onClick={() => editTruck(rowData)} />
            </div>
        );
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Gerenciar Caminhões</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar..." />
            </span>
        </div>
    );

    const productDialogFooter = (
        <>
            <Button label="Cancelar" disabled={disabled} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Salvar" onClick={handleTruck} loading={disabled} icon="pi pi-check" className="p-button-text"  />
        </>
    );
    const deleteTruckDialogFooter = (
        <>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hideDeleteTruckDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleDeleteTruck} />
        </>
    );

    useEffect(() => {
        listTrucks();
    }, []);
  
    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Toolbar className="mb-4" left={leftToolbarTemplate}></Toolbar>

                    <DataTable ref={dt} value={trucks} selection={selectedTrucks} onSelectionChange={(e) => setSelectedTrucks(e.value)}
                        dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Listando {first} a {last} de {totalRecords} registros"
                        globalFilter={globalFilter} emptyMessage="Nenhum registro encontrado." header={header} responsiveLayout="scroll">
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem'}}></Column>
                        <Column field="code" body={(rowData => String(rowData.code).padStart(4, '0'))} header="Código" sortable headerStyle={{ width: '14%', minWidth: '10rem' }}></Column>
                        <Column field="plate" body={rowData => rowData.plate.toUpperCase()} header="Placa" sortable headerStyle={{ width: '24%', minWidth: '10rem' }}></Column>
                        <Column field="axle" header="Eixos" sortable></Column>
                        <Column field="axle" body={rowData => (rowData.average_consumption || 0) ? (formatCurrency(rowData.average_consumption) + ' Km/L') : '-'} header="Consumo Médio" sortable></Column>
                        <Column body={actionBodyTemplate}></Column>
                    </DataTable>

                    <Dialog visible={truckDialog} style={{ width: '450px' }} header="Novo Caminhão" modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>
                        
                        <div className="field">
                            <label htmlFor="name">Placa</label>
                            <InputText disabled={disabled} style={{ textTransform: 'uppercase' }} id="name" value={truck.plate} onChange={(e) => onInputChange(e, 'plate')} required autoFocus className={classNames({ 'p-invalid p-error': submitted && !truck.plate })} />
                            {submitted && !truck.plate && <small className="p-invalid p-error">A placa é obrigatório.</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="description">Descrição</label>
                            <InputTextarea disabled={disabled} id="description" value={truck.description} onChange={(e) => onInputChange(e, 'description')} required rows={3} cols={20} />
                        </div>

                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="price">QTD. Eixos</label>
                                <InputNumber disabled={disabled} id="price" value={truck.axle} onValueChange={(e) => onInputChange(e, 'axle')} mode="decimal" className={classNames({ 'p-invalid p-error': submitted && !truck.axle })} useGrouping={false} />
                                {submitted && !truck.axle && <small className="p-invalid p-error">A quantidade de eixos é obrigatório.</small>}
                            </div>
                            <div className="field col">
                                <label htmlFor="quantity">Consumo médio (Km/L)</label>
                                <InputDecimal disabled={disabled} id="quantity" value={truck.average_consumption} onChange={(e) => onInputChange(e, 'average_consumption')}  />
                            </div>
                        </div>
                    </Dialog>

                    <Dialog visible={deleteTruckDialog} style={{ width: '450px' }} header="Atenção" modal footer={deleteTruckDialogFooter} onHide={hideDeleteTruckDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {truck && <span>Você tem certeza que deseja remover este caminhão?</span>}
                        </div>
                    </Dialog>
                    
                </div>
            </div>
        </div>
    );
}


export default Truck;